/* eslint-disable camelcase */
/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

// Action Creator
export const types = {
  REQUEST_LOGIN: "[Auth] Request login",
  REQUEST_LOGOUT: "[Auth] Request logout",
  LOGIN_SUCCESS: "[Auth] Login Success",
  LOG_OUT_SUCCESS: "[Auth] Logout Success",
  LOGIN_ERROR: "[Auth] Login Error",
  CHECK_AUTH: "[Auth] Check Auth",
  RESET_CURRENT_LOGIN_DETAILS: "[Auth] Reset Login values",
  CLEAR_AUTH: "[Auth] Clear Auth",
  FORGOT_PASSWORD: "[Auth] Request for forgot password",
  FORGOT_PASSWORD_SUCCESS: "[Auth] Forgot password Success",
  FORGOT_PASSWORD_REJECTED: "[Auth] Forgot password Rejected",

  CHANGE_PASSWORD: "[Auth] Request for change password",
  CHANGE_PASSWORD_SUCCESS: "[Auth] change password Success",
  CHANGE_PASSWORD_REJECTED: "[Auth] change password Rejected",
  REMOVE_CHANGE_PASS_RESPONSE: "[Auth] Remove change password response",

  RESET_PASSWORD: "[Auth] Request for reset password",
  RESET_PASSWORD_SUCCESS: "[Auth] reset password Success",
  RESET_PASSWORD_REJECTED: "[Auth] reset password Rejected",

  SIGNUP_USER: "[Signup] Signup",
  SIGNUP_USER_SUCCESS: "[Signup] Signup success",
  SIGNUP_USER_FAILED: "[Signup] Signup failed",
  COMPLETE_SIGNUP: "[Signup] Complete Signup",
  COMPLETE_SIGNUP_SUCCESS: "[Signup] Complete Signup success",
  COMPLETE_SIGNUP_FAILED: "[Signup] Complete Signup failed",
  REDIRECT_PENDING_USER: "[Signup] Redirect pending user",
  RESET_CURRENT_SIGUP_DETAILS: "[Signup] Reset Signup values",

  CARD_ADD: "[Card] Credit card add",
  CARD_ADD_SUCCESS: "[Card] Credit card add success",
  CARD_ADD_FAILED: "[Card] Credit card add failed",

  FETCH_CARD_DETAILS: "[Card] Fetch Card Details",
  FETCH_CARD_DETAILS_SUCCESS: "[Card] Fetch Card Details success",
  FETCH_CARD_DETAILS_FAILED: "[Card] Fetch Card Details failed",
  CLEAR_CARD_DETAILS: "[Card] Clear Card Details",
  CLEAR_CARD_ADD_ERROR: "[CARD] Clear Card Add Error",

  CHANGE_USER_STATUS: "[AUTH] Change user status",

  REGISTRATION_MESS_CLEAR: "[Auth] Registration Mess Clear",
  CLEAR_RESET_PASSWORD: "[Auth] Clear Reset Password",
  UPDATE_AUTH_ROLE: "[Auth] Update Auth Role",

  SOCIAL_SIGNUP: "[Auth] Social Signup",
  SOCIAL_SIGNUP_SUCCESS: "[Auth] Social Signup Success",
  SOCIAL_SIGNUP_FAILED: "[Auth] Social Signup Failed",

  REFRESH_HELP_SITE: "[Help Site] Help site refresh",
  REFRESH_HELP_SITE_SUCCESS: "[Help Site] Help site refresh Success",
  REFRESH_HELP_SITE_FAILED: "[Help Site] Help site refresh Failed",
  REFRESH_HELP_SITE_MSG_CLEAR: "[Help Site] Help site refresh msg clear",

  CHECK_ELIGIBILITY_SSO: "[SSO] Check Eligibility SSO",
  CHECK_ELIGIBILITY_SSO_SUCCESS: "[SSO] Check Eligibility SSO Success",
  CHECK_ELIGIBILITY_SSO_FAILED: "[SSO] Check Eligibility SSO Failed",

  CLEAR_CHECK_ELIGIBILITY_SSO: "[SSO] Clear Check Eligibility SSO",

  SSO_CALLBACK: "[SSO] SSO Callback",
  SSO_CALLBACK_SUCCESS: "[SSO] SSO Callback Success",
  SSO_CALLBACK_FAILED: "[SSO] SSO Callback Failed",

  CLEAR_SSO_CALLBACK: "[SSO] Clear SSO Callback",
};

//
// ─── CHECK AUTH ACTION ──────────────────────────────────────────────────────────
//

export const CheckAuth = () => ({
  type: types.CHECK_AUTH,
});

//
// ─── LOGIN ACTIONS ──────────────────────────────────────────────────────────────
//

export const RequestLogin = ({ email, password }) => ({
  type: types.REQUEST_LOGIN,
  payload: {
    email,
    password,
  },
});
export const LoginSuccess = (user) => ({
  type: types.LOGIN_SUCCESS,
  payload: user,
});
export const LoginError = (error) => ({
  type: types.LOGIN_ERROR,
  payload: error,
});

//
// ─── FORGOT PASSWORD ACTIONS ────────────────────────────────────────────────────
//

export const ForgotPassword = (email) => ({
  type: types.FORGOT_PASSWORD,
  payload: email,
});
export const ForgotPasswordSuccess = (message) => ({
  type: types.FORGOT_PASSWORD_SUCCESS,
  payload: message,
});
export const ForgotPasswordRejected = (message) => ({
  type: types.FORGOT_PASSWORD_REJECTED,
  payload: message,
});

//
// ─── LOGOUT ACTIONS ─────────────────────────────────────────────────────────────
//

export const RequestLogout = /* istanbul ignore next */ () => ({
  type: types.REQUEST_LOGOUT,
});
export const LogoutSuccess = /* istanbul ignore next */ (user) => ({
  type: types.LOG_OUT_SUCCESS,
  payload: user,
});

//
// ─── CHANGE PASSWORD ACTIONS ────────────────────────────────────────────────────
//

export const ChangePassword = ({ pass, flag }) => ({
  type: types.CHANGE_PASSWORD,
  payload: {
    pass,
    flag,
  },
});
export const ChangePasswordSuccess = (change_password_response) => ({
  type: types.CHANGE_PASSWORD_SUCCESS,
  payload: change_password_response,
});
export const ChangePasswordRejected = (change_password_response) => ({
  type: types.CHANGE_PASSWORD_REJECTED,
  payload: change_password_response,
});
export const RemoveChangePasswordResponse = /* istanbul ignore next */ () => ({
  type: types.REMOVE_CHANGE_PASS_RESPONSE,
});
//
// ─── RESET PASSWORD ACTIONS ─────────────────────────────────────────────────────
//

export const ResetPassword = (password, checksum, reCaptchaToken) => ({
  type: types.RESET_PASSWORD,
  payload: {
    password,
    checksum,
    reCaptchaToken,
  },
});
export const ResetPasswordSuccess = (reset_password_response) => ({
  type: types.RESET_PASSWORD_SUCCESS,
  payload: reset_password_response,
});
export const ResetPasswordRejected = (reset_password_response) => ({
  type: types.RESET_PASSWORD_REJECTED,
  payload: reset_password_response,
});
//
// ─── SIGN UP FOR CUSTOMERS ──────────────────────────────────────────────────────
//
export const Signup = (emailId, isMediaTailor) => ({
  type: types.SIGNUP_USER,
  payload: { emailId, isMediaTailor },
});
export const SignupSuccess = (response) => ({
  type: types.SIGNUP_USER_SUCCESS,
  payload: response,
});
export const SignupFailed = (error) => ({
  type: types.SIGNUP_USER_FAILED,
  payload: error,
});
//
// ─── SIGN UP COMPLETION ─────────────────────────────────────────────────────────
//
export const CompleteSignup = (userDetails) => ({
  type: types.COMPLETE_SIGNUP,
  payload: userDetails,
});
export const CompleteSignupSuccess = (response) => ({
  type: types.COMPLETE_SIGNUP_SUCCESS,
  payload: response,
});
export const CompleteSignupFailed = (error) => ({
  type: types.COMPLETE_SIGNUP_FAILED,
  payload: error,
});
// action that redirects the pending user to specific page after signup

export const RedirectToPendingUserView = (userDetails) => ({
  type: types.REDIRECT_PENDING_USER,
  payload: userDetails,
});
//
// ─── SIGN UP COMPLETION ─────────────────────────────────────────────────────────
//
export const CardAdd = (userDetails) => ({
  type: types.CARD_ADD,
  payload: userDetails,
});
export const CardAddSuccess = (response) => ({
  type: types.CARD_ADD_SUCCESS,
  payload: response,
});
export const CardAddFailed = (error) => ({
  type: types.CARD_ADD_FAILED,
  payload: error,
});
//
// ─── FETCH TRIAL PERIOD NOTIFICATIONS FOR ADMINS──────────────────────────────────────────────────────────────────────
//

export const FetchCardDetails = (companyId) => ({
  type: types.FETCH_CARD_DETAILS,
  payload: {
    companyId,
  },
});
export const FetchCardDetailsSuccess = (cardData) => ({
  type: types.FETCH_CARD_DETAILS_SUCCESS,
  payload: cardData,
});
export const FetchCardDetailsFailed = (error) => ({
  type: types.FETCH_CARD_DETAILS_FAILED,
  payload: error,
});

export const ClearCardDetails = () => ({
  type: types.CLEAR_CARD_DETAILS,
});

export const ClearCardAddError = () => ({
  type: types.CLEAR_CARD_ADD_ERROR,
});

//
// ─── RESET CURRENT SIGNUP / REGISTARTION DATA───────────────────────────────────────────────────
//
export const ResetCurrentSignupData = () => ({
  type: types.RESET_CURRENT_SIGUP_DETAILS,
});
//

//
// ─── RESET CURRENT SIGNIN ERROR ─────────────────────────────────────────────────
//

export const ResetCurrentLoginData = () => ({
  type: types.RESET_CURRENT_LOGIN_DETAILS,
});

// ─── CHANGE USER STATUS───────────────────────────────────────────────────
//
export const ChangeUserStatus = (status) => ({
  type: types.CHANGE_USER_STATUS,
  payload: status,
});

// ─── REGISTRATION MESS CLEAR───────────────────────────────────────────────────
//
export const RegistrationMessClear = () => ({
  type: types.REGISTRATION_MESS_CLEAR,
});
export const ClearResetPassword = () => ({
  type: types.CLEAR_RESET_PASSWORD,
});
export const ClearAuth = () => ({
  type: types.CLEAR_AUTH,
});
export const UpdateAuthRole = (role) => ({
  type: types.UPDATE_AUTH_ROLE,
  payload: role,
});

export const SocialSignup = (urldetails) => ({
  type: types.SOCIAL_SIGNUP,
  payload: urldetails,
});
export const SocialSignupSuccess = (response) => ({
  type: types.SOCIAL_SIGNUP_SUCCESS,
  payload: response,
});
export const SocialSignupFailed = (error) => ({
  type: types.SOCIAL_SIGNUP_FAILED,
  payload: error,
});

export const RefreshHelpSite = () => ({
  type: types.REFRESH_HELP_SITE,
});
export const RefreshHelpSiteSuccess = (response) => ({
  type: types.REFRESH_HELP_SITE_SUCCESS,
  payload: response,
});
export const RefreshHelpSiteFailed = (error) => ({
  type: types.REFRESH_HELP_SITE_FAILED,
  payload: error,
});
export const RefreshHelpSiteMsgClear = () => ({
  type: types.REFRESH_HELP_SITE_MSG_CLEAR,
});

export const CheckEligibilitySSO = (email) => ({
  type: types.CHECK_ELIGIBILITY_SSO,
  payload: email,
});
export const CheckEligibilitySSOSuccess = (response) => ({
  type: types.CHECK_ELIGIBILITY_SSO_SUCCESS,
  payload: response,
});
export const CheckEligibilitySSOFailed = (error) => ({
  type: types.CHECK_ELIGIBILITY_SSO_FAILED,
  payload: error,
});
export const ClearCheckEligibilitySSO = () => ({
  type: types.CLEAR_CHECK_ELIGIBILITY_SSO,
});
export const SSOCallback = (urldetails) => ({
  type: types.SSO_CALLBACK,
  payload: urldetails,
});
export const SSOCallbackSuccess = (response) => ({
  type: types.SSO_CALLBACK_SUCCESS,
  payload: response,
});
export const SSOCallbackFailed = (error) => ({
  type: types.SSO_CALLBACK_FAILED,
  payload: error,
});
export const ClearSSOCallback = () => ({
  type: types.CLEAR_SSO_CALLBACK,
});
